<div class="map-tools-panel" [@slideInOut]="slideState" [style.z-index]="zIndex" [hidden]="loadingMap" fxLayout="column"
    fxLayoutGap="1.5vh" style="overflow: auto; scrollbar-color: #ffffff transparent;">
    <div fxFlex fxGrow="0" class="hide-filters-icon" fxLayoutAlign="end center">
        <mat-icon [matTooltip]="'Hide Map Tools' | translate" (click)="closed.emit()">close</mat-icon>
    </div>
    <div fxFlex fxLayout="column" fxLayoutGap="2vh" fxGrow="0" style="margin-top: 1.5vh;">
        <div fxFlex fxLayout="column" fxLayoutGap="2vh" fxGrow="0">
            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 1vh;" fxLayoutGap="1vw">
                <span fxFlex="60" fxGrow="0" class="section-title"
                    style="margin-bottom: 1vh; font-weight: bold;">{{'Drag & Drop Pins' |
                    translate}}</span>
                <div fxFlex fxGrow="0" fxLayoutAlign="center end">
                    <button mat-mini-fab class="add-custom-icon" (click)="openGallery.emit()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
            <div
                style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1vh; max-height: calc(3 * (50px + 1vh)); overflow-y: auto;scrollbar-color: #ffffff transparent; scrollbar-width: thin;">
                <!-- <button mat-icon-button (click)="openGallery.emit()" *ngIf="isSuperAdmin"
                    style="padding: 6px;width: 40px; height: 40px; justify-self: center; cursor: pointer;"
                    [matTooltip]="'Add' | translate">
                    <mat-icon style="color: rgba(255,255,255,0.7);">add_photo_alternate</mat-icon>
                </button> -->
                <ng-container *ngIf="squadGalleryList.length">
                    <img *ngFor="let squad of squadGalleryList; trackBy: trackById" [src]="squad.imageLink" [alt]="''" [draggable]="true"
                        (dragstart)="squadDragStart.emit({ event: $event, squad })"
                        (error)="$event.target.src='assets/images/icon/template.png'; $event.stopPropagation()"
                        style="width: 50px; height: 50px; object-fit: contain; cursor: grab; justify-self: center;" />
                </ng-container>
            </div>
        </div>
        <div fxFlex fxLayout="column" fxLayoutGap="2vh" fxGrow="0">
            <!-- <div style="border-top: 1px solid rgba(255,255,255,0.12); margin-bottom: 2vh;"></div> -->
            <span fxFlex fxGrow="0" style="margin-bottom: 1vh; font-weight: bold;" class="section-title">{{'Team
                Members' |
                translate}}</span>
            <div style="margin-bottom: 1vh;">
                <div class="search-container"
                    style="background: rgba(255,255,255,0.05); border-radius: 4px; padding: 4px 8px; display: flex; align-items: center;">
                    <mat-icon
                        style="font-size: 18px; width: 18px; height: 18px; color: rgba(255,255,255,0.5); margin-right: 8px;">search</mat-icon>
                    <input type="text" maxlength="200" [(ngModel)]="searchTerm"
                        placeholder="{{'Search' | translate}}..."
                        style="background: transparent; border: none; color: white; outline: none; width: 100%; font-size: 13px;">
                    <mat-icon *ngIf="searchTerm" (click)="searchTerm = ''"
                        style="font-size: 18px; width: 18px; height: 18px; color: rgba(255,255,255,0.5); cursor: pointer;">close</mat-icon>
                </div>
            </div>
            <div fxLayout="column" fxLayoutGap="1vh"
                style="max-height: 30vh; overflow-y: auto;scrollbar-color: #ffffff transparent; scrollbar-width: thin;">
                <ng-container *ngIf="filteredInvestigators.length">
                    <ng-container *ngFor="let user of filteredInvestigators; trackBy: trackById">
                        <ng-container *ngIf="user.isGroup">
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0" [draggable]="true"
                                (dragstart)="investigatorDragStart.emit({ event: $event, user })"
                                style="padding-left: 3px; cursor: grab; border-radius: 4px; transition: background-color 0.2s;"
                                (mouseenter)="$event.currentTarget.style.backgroundColor='rgba(255,255,255,0.1)'"
                                (mouseleave)="$event.currentTarget.style.backgroundColor='transparent'">
                                <div class="image-container" style="flex-shrink: 0;">
                                    <img [src]="user.picture || 'assets/images/icon/group-default-white.png'"
                                        [alt]="user.name" class="item-image role-border-group"
                                        style="width: 25px; height: 25px;"
                                        (error)="$event.target.src='assets/images/icon/group-default-white.png'" />
                                </div>
                                <span
                                    style="color: rgba(255,255,255,0.9); flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: bold;">
                                    {{user.name}}
                                </span>
                                <button mat-icon-button *ngIf="showLocate(user)" style="padding-right: 0 !important;"
                                    (click)="logTeammemberMarkers.emit({ event: $event, userId: user._id })"
                                    [matTooltip]="'Locate' | translate">
                                    <mat-icon>place</mat-icon>
                                </button>
                            </div>
                        </ng-container>
                        <div *ngIf="!user.isGroup" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0"
                            [draggable]="true" (dragstart)="investigatorDragStart.emit({ event: $event, user })"
                            style="padding-left: 3px; cursor: grab; border-radius: 4px; transition: background-color 0.2s;"
                            (mouseenter)="$event.currentTarget.style.backgroundColor='rgba(255,255,255,0.1)'"
                            (mouseleave)="$event.currentTarget.style.backgroundColor='transparent'">
                            <div class="image-container" style="flex-shrink: 0;">
                                <img [src]="user.pictureLink || 'assets/images/profile.png'"
                                    [alt]="user.alternative_name || user.name" class="item-image"
                                    [class.role-border-red]="user['role'] == 'Admin'"
                                    [class.role-border-green]="user['role'] == 'Investigator'"
                                    [class.role-border-orange]="user['role'] == 'Commander'"
                                    [class.role-border-black]="user['role'] == 'Technician'"
                                    style="width: 25px; height: 25px;"
                                    (error)="$event.target.src='assets/images/profile.png'" />
                            </div>
                            <span
                                style="color: rgba(255,255,255,0.9); flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                {{user.alternative_name || user.name}}
                            </span>
                            <button mat-icon-button *ngIf="showLocate(user)" style="padding-right: 0 !important;"
                                (click)="logTeammemberMarkers.emit({ event: $event, userId: user._id })"
                                [matTooltip]="'Locate' | translate">
                                <mat-icon>place</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div fxFlex fxLayout="column" fxLayoutGap="2vh" fxGrow="0">
            <app-base-stations-list [baseStations]="baseStations" [caseId]="caseId"
                [isBaseStationFilterOn]="isBaseStationFilterOn"
                (addAntennaBasedLocation)="addAntennaBasedLocation.emit()" [isInvestigator]="isInvestigator"
                (editAntennaBasedLocation)="editAntennaBasedLocation.emit($event)"
                (locateAreaInterestOutput)="locateAreaInterestOutput.emit($event)"
                (toggleBaseStations)="toggleBaseStations.emit($event)"></app-base-stations-list>
        </div>
        <div fxFlex *ngIf="platesOfInterestDisplay.length" fxLayout="column" fxLayoutGap="0" fxGrow="0">
            <!-- <div style="border-top: 1px solid rgba(255,255,255,0.12); margin-bottom: 2vh;"></div> -->
            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 1vh;" fxLayoutGap="1vw">
                <span fxFlex="60" fxGrow="0" style="margin-bottom: 1vh; font-weight: bold;" class="section-title">{{'Car
                    of Interest' |
                    translate}}</span>
                <div fxFlex fxGrow="0" fxLayoutAlign="center end">
                    <button mat-mini-fab class="add-custom-icon" (click)="addCarOfInterest.emit()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
            <div *ngFor="let plate of platesOfInterestDisplay; trackBy: trackByInterest" fxFlex fxGrow="0" class="options-container">
                <mat-slide-toggle [checked]="plate.isChecked"
                    (change)="plateToggle.emit({ plate, checked: $event.checked })"></mat-slide-toggle>
                <div>
                    {{plate.plate_of_interest || plate.car_of_interest_identifier}}</div>
                <button mat-icon-button class="go-to" (click)="selectInterestNote.emit(plate)"
                    [matTooltip]="'Locate' | translate">
                    <mat-icon>place</mat-icon>
                </button>
            </div>
        </div>
        <div fxFlex *ngIf="peopleOfInterestDisplay.length" fxLayout="column" fxLayoutGap="0" fxGrow="0">
            <!-- <div style="border-top: 1px solid rgba(255,255,255,0.12); margin-bottom: 2vh;"></div> -->
            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 1vh;" fxLayoutGap="1vw">
                <span fxFlex="60" fxGrow="0" class="section-title"
                    style="margin-bottom: 1vh; font-weight: bold;">{{'Person of Interest' |
                    translate}}</span>
                <div fxFlex fxGrow="0" fxLayoutAlign="center end">
                    <button mat-mini-fab class="add-custom-icon" (click)="addPersonOfInterest.emit()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
            <div *ngFor="let person of peopleOfInterestDisplay; trackBy: trackByInterest" fxFlex fxGrow="0" class="options-container">
                <mat-slide-toggle [checked]="person.isChecked"
                    (change)="personToggle.emit({ person, checked: $event.checked })"></mat-slide-toggle>
                <div>
                    {{person.person_of_interest_name}}</div>
                <button mat-icon-button class="go-to" (click)="selectInterestNote.emit(person)"
                    [matTooltip]="'Locate' | translate">
                    <mat-icon>place</mat-icon>
                </button>
            </div>
        </div>
        <div fxFlex *ngIf="sites.length && enableSiteMapping" fxLayout="column" fxLayoutGap="0" fxGrow="0">
            <!-- <div style="border-top: 1px solid rgba(255,255,255,0.12); margin-bottom: 2vh;"></div> -->
            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 1vh;" fxLayoutGap="1vw">
                <span fxFlex="60" class="section-title" fxGrow="0"
                    style="margin-bottom: 1vh; font-weight: bold;">{{'Sites' |
                    translate}}</span>
                <div fxFlex fxGrow="0" fxLayoutAlign="center end">
                    <button mat-mini-fab class="add-custom-icon" (click)="addSite.emit()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
            <div *ngFor="let site of sites" fxFlex fxGrow="0" class="options-container" style="margin-left: 0.65vw;">
                <!-- <mat-slide-toggle [checked]="site.isChecked"
                    (change)="personToggle.emit({ site, checked: $event.checked })"></mat-slide-toggle> -->
                <div>
                    {{site.name}}</div>
                <button mat-icon-button class="go-to" (click)="selectSite.emit(site)"
                    [matTooltip]="'Locate' | translate">
                    <mat-icon>place</mat-icon>
                </button>
            </div>
        </div>
        <div fxFlex *ngIf="safeRoutes.length && enableSiteMapping" fxLayout="column" fxLayoutGap="0" fxGrow="0">
            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom: 1vh;" fxLayoutGap="1vw">
                <span fxFlex="60" class="section-title" fxGrow="0"
                    style="margin-bottom: 1vh; font-weight: bold;">{{'Route' | translate}}</span>
            </div>
            <div *ngFor="let route of safeRoutes; let i = index" fxFlex fxGrow="0" class="options-container"
                style="margin-left: 0.65vw;">
                <div class="route-color-dot" [style.background-color]="route?.color || '#4CAF50'" aria-hidden="true">
                </div>
                <div>
                    {{route.name || (('Route' | translate) + ' ' + (i + 1))}}
                </div>
                <button mat-icon-button class="go-to" (click)="selectSafeRoute.emit(route)"
                    [matTooltip]="'Locate' | translate">
                    <mat-icon>place</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
